import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function GiftCard() {
  return <section id="giftcard" data-nav="light" className="relative bg-[#43362F] text-[#FCFAF7] py-20 md:py-28 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 sm:px-8 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Column: Editorial Line-Drawn / Warm Illustration */}
          <div className="lg:col-span-6 flex justify-center">
            <div className="relative w-full max-w-md lg:max-w-none rounded-2xl overflow-hidden border border-[#A77B62]/30 bg-[#3a2e27] p-4 sm:p-6 shadow-sm">
              <div className="relative aspect-4/5 w-full rounded-xl overflow-hidden bg-secondary/30">
                <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/gift_card_illustration.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/gift_card_illustration.webp-wvc-sizes" alt="Illustration éditoriale d'une jeune maman enveloppée et soutenue avec douceur" loading="lazy" decoding="async" className="w-full h-full object-cover object-center" src="https://slow-mama.com/wp-content/uploads/2026/10/53577606-3ce6-4703-98bc-e8a29be1d3a2.png" />
              </div>
            </div>
          </div>

          {/* Right Column: Editorial Copy */}
          <div className="lg:col-span-6 flex flex-col items-start space-y-6 text-left">
            <span className="text-xs uppercase font-medium tracking-widest text-[#A77B62] font-default">Cadeau de naissance pour maman | Slow Mama</span>

            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal leading-[1.15] text-[#FCFAF7] tracking-normal">Un cadeau dont une future maman ce souviendra à toujours</h2>

            <p className="text-[#FCFAF7]/90 font-default text-base sm:text-lg leading-relaxed">Offre-lui du temps pour souffler, un repas préparé chez elle et une présence attentive pour prendre soin d'elle aussi. Avec une carte cadeau SLOW MAMA, tu lui offres un soutien concret, adapté à ses besoins après la naissance.</p>

            <p className="text-[#FCFAF7]/75 font-default text-sm sm:text-base leading-relaxed">Tu peux offrir une visite à domicile, une séance de batch cooking ou contribuer à un accompagnement sur plusieurs semaines. Nous choisissons ensemble la formule à offrir.</p>

            <div className="pt-2">
              <Button asChild className="border border-[#A77B62]/70 bg-transparent text-[#FCFAF7] hover:bg-[#A77B62] hover:text-[#43362F] hover:border-[#A77B62] rounded-full px-8 py-6 text-sm font-medium tracking-wider uppercase transition-colors duration-200">
                <Link to="/ContactPage?forfait=carte-cadeau">
                  OFFRIR UNE CARTE CADEAU →
                </Link>
              </Button>
            </div>

            <p className="text-xs sm:text-sm text-[#FCFAF7]/70 font-default pt-1">
              Tu hésites sur le cadeau ? Écris-moi, je t&apos;aide à choisir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}